/* eslint-disable @typescript-eslint/naming-convention */

// eslint-disable-next-line @typescript-eslint/naming-convention,no-shadow
export enum ClevertapEvent {
  LOGIN = 'login',

  WATCHED = 'Watched',

  VIEW_PLANS = 'View_Plans',

  TRAY = 'trayevent',

  LANGUAGE_UPDATE = 'Language_Update',

  SEARCH = 'Searched',

  MEDIA_ERROR = 'Media_Error',

  LOGOUT = 'Logout',

  CONTENT_CLICKED = 'Content_Clicked',

  CREATE_PROFILE = 'Create_Profile',

  EDIT_PROFILE = 'Edit_Profile',

  SKIP_INTRO = 'Skip_Intro',

  ADD_WATCHLIST = 'Added_To_Watchlist',

  LINK_DEVICE = 'Link_Device',

  SUBSCRIPTION_INITIATED = 'subscription_initiated',

  SUBSCRIPTION = 'Subscription',

  WATCHLIST = 'watchlist',

  PAYMENT_INITIATED = 'Payment_Initiated',

  PAGE_VIEW = 'Page_View',

  REMOVE_WATCHLIST = 'Removed_From_Watchlist',

  CLICKED_WATCH_ON_RENT = 'Clicked_Watch_On_Rent',

  SEE_ALL_CLICKED = 'See_All_Clicked',

  AD_BREAK_START = 'AD_BREAK_START',
  AD_START = 'AD_START',
  AD_BREAK_COMPLETE = 'AD_BREAK_COMPLETE',
  AD_END = 'AD_END',
  BANNER_AD_CLICK = 'BANNER_AD_CLICK',
}
